
import { defineComponent, PropType } from "vue"
import { Service } from "@/js/types/service"
import { User } from "@/js/types/user"
import MessengerNotifications from "@/js/Pages/Dashboard/_MessengerNotifications.vue"

export default defineComponent({
    name: "DashboardSidebar",
    components: { MessengerNotifications },
    props: {
        messengerUnreadCount: { type: Number, default: 0 },
        userServices: {
            type: Array as PropType<Service[]>,
            required: true,
        },
    },
    emits: ["open-service", "messenger-unread-change", "open-messenger"],
    data: () => ({
        isCollapsed: false,
        isMobileOpened: false,
    }),
    computed: {
        hasMessenger(): boolean {
            return this.userServices.some((service) => service.name === "messenger.agent")
        },
        user(): User {
            return this.$page.props.auth.user
        },
        openedService(): Service {
            return {
                id: -1,
                name: "test",
                title: "Test",
                url: "test",
                iconUri: null,
                forceExternalOpen: false,
            }
        },
    },
    methods: {
        openMessenger() {
            this.isMobileOpened = false
            this.$emit("open-messenger")
        },
        openService(service: Service, inNewTab: boolean = false) {
            this.isMobileOpened = false
            document?.scrollingElement?.scrollTo(0, 0)

            if (!service.forceExternalOpen) this.$emit("open-service", service, inNewTab)
        },
    },
})
